export default "__VITE_ASSET__LuH_yafC__"